// Vite-injected env. In dev the SPA hits its own origin and Vite proxies
// /v1/auth/* → :8788 and /v1/api/* → :8787. In prod a single LB fronts both.
// Either way the SPA is same-origin with the auth + api services, so the
// refresh cookie is first-party and SameSite=Strict works.

export const AUTH_BASE_URL = (import.meta.env.VITE_AUTH_BASE_URL as string | undefined) ?? '';
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api';

/** Tile-edge base. Defaults to the same-origin nginx proxy path `/api/tiles`,
 *  which `apps/terminal/nginx.conf` routes to the in-cluster tile-edge
 *  service. Override at build time via `VITE_TILES_BASE_URL=https://...`
 *  for a cross-origin tile host. The empty-string vs undefined coercion is
 *  load-bearing: an empty build-arg used to silently produce `/v1/esri/...`
 *  URLs that bypass the nginx rewrite and 404. */
const _tilesEnv = (import.meta.env.VITE_TILES_BASE_URL as string | undefined)?.trim();
export const TILES_BASE_URL = _tilesEnv && _tilesEnv.length > 0 ? _tilesEnv : '/api/tiles';
